import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import image from '../assest/logo.png'
import {useLanguageStore} from "../store/languageStore";

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [langDropdownOpen, setLangDropdownOpen] = useState(false);
    const location = useLocation();
    const { language, setLanguage } = useLanguageStore()


    // Available languages
    const languages = [
        { code: 'en', name: 'English' },
        { code: 'ar', name: 'العربية' },
    ];

    // Navigation items based on your website structure
    const navItems = [
        { name: language === 'en' ? 'Home' : 'الرئيسية', path: '/' },
        { name: language === 'en' ?'About Us' :"نبذة عنا", path: '/about' },
        {
            name: language === 'en' ? 'Products' : 'المنتجات',
            path: '/products',


        },
        { name: language === 'en' ? 'Solutions' : "الحلول", path: '/solutions' },
        { name: language === 'en' ? 'Documents': "المستندات", path: '/documents' },
    ];




    // Function to toggle dropdown menu for mobile
    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    // Function to toggle language dropdown
    const toggleLangDropdown = () => {
        setLangDropdownOpen(!langDropdownOpen);
    };

    // Function to change language
    const changeLanguage = (langCode) => {
        setLanguage(langCode);
        setLangDropdownOpen(false);
    };

    // Function to check if a nav item is active
    const isActive = (path) => {
        if (path === '/') {
            return location.pathname === path;
        }
        return location.pathname.startsWith(path);
    };

    return (
        <nav className="bg-white shadow-md sticky top-0 z-20">
            <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className={`flex ${language === 'ar' && 'flex-row-reverse'} justify-between h-16`}>
                    {/* Logo */}
                    <div className="flex-shrink-0 flex items-center">
                        <Link to="/" className="flex items-center">
                            <img loading="lazy"
                                src={image}
                                alt="DJIDAR Logo"
                                className="h-12 w-auto"
                            />
                        </Link>
                    </div>

                    {/* Desktop Navigation */}
                    <div className={`hidden md:flex ${language === 'ar' && 'md:flex-row-reverse'} md:items-center `}>
                        {navItems.map((item) => (
                            !item.dropdown ? (
                                <Link
                                    key={item.name}
                                    to={item.path}
                                    className={`inline-flex  items-center px-5 pt-1 text-sm font-medium border-b-2 ${
                                        isActive(item.path)
                                            ? 'border-teal-500 text-gray-900'
                                            : 'border-transparent text-gray-500 hover:border-teal-300 hover:text-gray-700'
                                    }`}
                                >
                                    {item.name}
                                </Link>
                            ) : (
                                <div key={item.name} className="relative group">
                                    <button
                                        className={`inline-flex items-center px-1 pt-1 text-sm font-medium border-b-2 ${
                                            isActive(item.path)
                                                ? 'border-teal-500 text-gray-900'
                                                : 'border-transparent text-gray-500 hover:border-teal-300 hover:text-gray-700'
                                        }`}
                                    >
                                        {item.name}
                                        <svg
                                            className="ml-2 h-4 w-4"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                            aria-hidden="true"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </button>
                                    <div className="absolute z-10 hidden group-hover:block pt-2 w-48">
                                        <div className="rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                                            <div className="py-1" role="menu" aria-orientation="vertical">
                                                {item.items.map((subItem) => (
                                                    <Link
                                                        key={subItem.name}
                                                        to={subItem.path}
                                                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                                    >
                                                        {subItem.name}
                                                    </Link>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        ))}

                        {/* Language Selector - Desktop */}
                        <div className="relative">
                            <button
                                onClick={toggleLangDropdown}
                                className="inline-flex items-center px-1 pt-1 text-sm font-medium border-b-2 border-transparent text-gray-500 hover:border-teal-300 hover:text-gray-700"
                                aria-expanded={langDropdownOpen}
                            >
                                <span className="mr-1">{languages.find(lang => lang.code === language)?.name}</span>
                                <svg
                                    className="h-4 w-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </button>
                            {langDropdownOpen && (
                                <div className="absolute right-0 z-10 mt-2 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                                    <div className="py-1" role="menu" aria-orientation="vertical">
                                        {languages.map((lang) => (
                                            <button
                                                key={lang.code}
                                                onClick={() => changeLanguage(lang.code)}
                                                className={`block w-full text-left px-4 py-2 text-sm ${
                                                    language === lang.code
                                                        ? 'bg-gray-100 text-gray-900'
                                                        : 'text-gray-700 hover:bg-gray-50'
                                                }`}
                                                role="menuitem"
                                            >
                                                {lang.name}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <div></div>

                    {/* Mobile menu button and language selector */}
                    <div className="md:hidden flex items-center space-x-2">
                        {/* Mobile Language Selector */}
                        <div className="relative">
                            <button
                                onClick={toggleLangDropdown}
                                className="inline-flex items-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-teal-500"
                                aria-expanded={langDropdownOpen}
                            >
                                <span className="sr-only">Select language</span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-6 w-6"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
                                    />
                                </svg>
                            </button>
                            {langDropdownOpen && (
                                <div className="absolute right-0 z-10 mt-2 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                                    <div className="py-1" role="menu" aria-orientation="vertical">
                                        {languages.map((lang) => (
                                            <button
                                                key={lang.code}
                                                onClick={() => changeLanguage(lang.code)}
                                                className={`block w-full text-left px-4 py-2 text-sm ${
                                                    language === lang.code
                                                        ? 'bg-gray-100 text-gray-900'
                                                        : 'text-gray-700 hover:bg-gray-50'
                                                }`}
                                                role="menuitem"
                                            >
                                                {lang.name}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Mobile menu toggle button */}
                        <button
                            onClick={toggleMenu}
                            className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-teal-500"
                            aria-expanded="false"
                        >
                            <span className="sr-only">Open main menu</span>
                            {isOpen ? (
                                <svg
                                    className="block h-6 w-6"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    aria-hidden="true"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            ) : (
                                <svg
                                    className="block h-6 w-6"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    aria-hidden="true"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M4 6h16M4 12h16M4 18h16"
                                    />
                                </svg>
                            )}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile menu, show/hide based on menu state */}
            <div className={`${isOpen ? 'block' : 'hidden'} md:hidden`}>
                <div className="pt-2 pb-3 space-y-1">
                    {navItems.map((item) => (
                        <div key={item.name}>
                            {!item.dropdown ? (
                                <Link
                                    to={item.path}
                                    className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium ${
                                        isActive(item.path)
                                            ? 'bg-teal-50 border-teal-500 text-teal-700'
                                            : 'border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800'
                                    }`}
                                    onClick={() => setIsOpen(false)}
                                >
                                    {item.name}
                                </Link>
                            ) : (
                                <>
                                    <button
                                        className={`w-full flex justify-between items-center pl-3 pr-4 py-2 border-l-4 text-base font-medium ${
                                            isActive(item.path)
                                                ? 'bg-teal-50 border-teal-500 text-teal-700'
                                                : 'border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800'
                                        }`}
                                        onClick={() => {
                                            const elem = document.getElementById(`mobile-${item.name}`);
                                            if (elem) {
                                                elem.classList.toggle('hidden');
                                            }
                                        }}
                                    >
                                        {item.name}
                                        <svg
                                            className="ml-2 h-4 w-4"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                            aria-hidden="true"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </button>
                                    <div id={`mobile-${item.name}`} className="hidden pl-6">
                                        {item.items.map((subItem) => (
                                            <Link
                                                key={subItem.name}
                                                to={subItem.path}
                                                className="block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800"
                                                onClick={() => setIsOpen(false)}
                                            >
                                                {subItem.name}
                                            </Link>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    ))}

                    {/* Mobile Language Selector (full width option in dropdown) */}
                    <div className="pt-4 pb-2 border-t border-gray-200">
                        <div className="flex items-center px-4">
                            <div className="flex-shrink-0">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-6 w-6 text-gray-400"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
                                    />
                                </svg>
                            </div>
                            <div className="ml-3">
                                <div className="text-base font-medium text-gray-800">Language</div>
                                <div className="text-sm font-medium text-gray-500">
                                    {languages.find(lang => lang.code === language)?.name}
                                </div>
                            </div>
                        </div>
                        <div className="mt-3 space-y-1">
                            {languages.map((lang) => (
                                <button
                                    key={lang.code}
                                    onClick={() => {
                                        changeLanguage(lang.code);
                                        setIsOpen(false);
                                    }}
                                    className={`block w-full text-left pl-10 pr-4 py-2 border-l-4 ${
                                        language === lang.code
                                            ? 'bg-teal-50 border-teal-500 text-teal-700'
                                            : 'border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800'
                                    }`}
                                >
                                    {lang.name}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;